<template>
	<div class="modal-card">
		<div class="modal-card-head">
			<p class="modal-card-title">Save Search</p>
			<div class="modal-close-button" @click="$parent.close()"></div>
		</div>
		<div class="modal-card-body">
			<div id="opportunityModal" class="columns">
				<div class="column">
					<b-input type="text" placeholder="Enter a name for the query" v-model="QueryName"></b-input>
				</div>
			</div>
		</div>
		<div class="modal-card-foot">
			<b-button class="is-primary" @click="saveSearch">Save</b-button>
			<b-button class="is-grey" @click="$parent.close()">Close</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			Search: Object
		},
		data() {
			return {
				QueryName: ""
			}
		},
		methods: {
			saveSearch() {
				if (this.QueryName) {
					this.Search.QueryName = this.QueryName;
					this.$http.post("api/search/save", this.Search)
						.then(resp => {
							this.$buefy.toast.open({
								message: "You have successfully saved your search.",
								type: "is-success"
							})
							this.$parent.close();
						}).catch(err => {
							console.log(err);
						})
				}
				else {
					this.$buefy.toast.open({
						message: "You must fill out the Query Name field.",
						type: "is-danger"
					})
				}
			}
		}
	}
</script>
